import { usePost } from "../usePost";
import { ASK_GPC_CHAT_API_PATH } from "../../constants";
import { chatMessageSerializer } from "../../utils";

export const usePostAskGpcQuestion = () => {
  return usePost({
    url: ASK_GPC_CHAT_API_PATH,
    serializer: chatMessageSerializer,
  });
};
